import {Modal} from 'react-bootstrap'

export const ErrorModal = (props: any) => {
  return (
    <Modal
      show={props.modalState}
      dialogClassName='ePulse-modal ePulse-modal-50w'
      onHide={() => props.closeModal()}
      backdrop='static'
    >
      <Modal.Header className='border-0' closeButton>
        <span className='fs-3 fw-bold'>Field Data are missing or Wrong</span>
      </Modal.Header>
      <Modal.Body className='container' />
      <div className='ePulse-modal-content'>
        {props.errorMessage.map((item: any, index: number) => {
          const indexOfIN = item.indexOf('in ')

          const beforePart = item.substring(0, indexOfIN).trim()
          const afterPart = item.substring(indexOfIN + 2).trim()

          return (
            <div key={index} style={{display: 'flex'}}>
              <div style={{padding: 10, color: '#000'}}>{beforePart} </div>
              <div style={{padding: 10, color: 'red', fontWeight: 'bold'}}>{afterPart}</div>
            </div>
          )
        })}
        <div className='btn-row'>
          {/* <button className='ePulse-btn-primary' type='button' onClick={() =>props.onCancel()}>cancel</button>
       <button className='ePulse-btn-primary' type='button' onClick={() =>props.onDelete()}>
        Delete
       </button> */}
        </div>
      </div>
    </Modal>
  )
}
